import React, { useCallback, useRef } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import SydModal from '../../../../components/commonDesign/SydModal'
import { actionPipelines } from '../../../../api/coreData'
import { smartEndpoints } from '../../../../api/smartEndpoints'
import Loading from '../../../../components/molecules/Loading'
import FadeIn from '../../../../components/molecules/Transitions/FadeIn'
import ErrorDisplay from '../../../../components/molecules/ErrorDisplay'
import DynamicActionForm from '../../../../components/organisms/DenaliActionPipeline/form/DynamicActionForm'
import { useDenaliActions } from '../../../../components/organisms/DenaliActionPipeline/provider/DenaliActionProvider'

function MeetingActionDialog () {
  const formRef = useRef(null)
  const queryClient = useQueryClient()
  const { close, dialogState } = useDenaliActions()
  const { data: actionTemplate, isLoading, error } = actionPipelines.useActionTemplate(dialogState?.code)
  const invokeSE = smartEndpoints.useInvokeSmartEndpoint()

  const handleSubmit = useCallback(async (args) => {
    const code = actionTemplate?.definition?.actionPipelineCode
    const result = await invokeSE.mutateAsync({ code, args })
    if (result?.success === false) return result
    queryClient.invalidateQueries({ queryKey: ['denali/meetings'] })
    queryClient.invalidateQueries({ queryKey: ['denali/meeting'] })
    close()
    return result
  }, [actionTemplate, invokeSE, queryClient, close])

  return (
    <SydModal
      open={dialogState?.open}
      onClose={(e) => formRef.current?.cancel?.(e) ?? close(e)}
      size='mediumLarge'
      position='top'
      disablePortal={false}
    >
      <FadeIn key={`MeetingActionDialog_${dialogState?.code || 'empty'}`}>
        {error ? (
          <ErrorDisplay error={error} />
        ) : isLoading ? (
          <Loading />
        ) : actionTemplate ? (
          <DynamicActionForm
            ref={formRef}
            actionTemplate={actionTemplate}
            onSubmit={handleSubmit}
            onCancel={close}
            subject={dialogState?.subject}
            variables={dialogState?.variables}
          />
        ) : null}
      </FadeIn>
    </SydModal>
  )
}

export default MeetingActionDialog
